import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as FileSaver from 'file-saver';
import * as JSZip from 'jszip';
import { Message } from 'src/app/interfaces/message';
import { MessageService } from 'src/app/services/api/message.service';
import { LoadingService } from 'src/app/services/loading.service';
import { UserService } from 'src/app/services/user.service';
import { ResponseModalComponent } from '../../modals/response-modal/response-modal.component';

@Component({
  selector: 'app-open-message',
  templateUrl: './open-message.component.html',
  styleUrls: ['./open-message.component.scss']
})
export class OpenMessageComponent implements OnInit {

    loading$ = this.loader.loading$;

    @Input() message: Message | undefined;
    @Input() ref: string | undefined;

    public errorMessage: string = '' ;
    public errorType: string = '';

    public signatories: Array<string> | undefined;

    constructor(public messageApi: MessageService,
                public userService: UserService,
                private modalService: NgbModal,
                public sanitizer: DomSanitizer,
                public loader: LoadingService) { }

    ngOnInit(): void {
        this.signatories = this.message?.recipient.split(';');
    }

    downloadAttachment(filename: string) {
        if (this.ref) {
            this.loader.show("OPEN.DOWNLOAD-ATTACHMENT", {filename :  filename});

            this.messageApi.downloadAttachment(filename, this.ref).subscribe((res) => {
                if (res.result == "SUCCESS") {
                    this.loader.hide();
                    const text = res.content.content;
                    var download = document.createElement('a');
                    download.href = 'data:' + res.content.type + ';base64,' + text;
                    download.download = res.content.name;
                    download.click();
                    if (document.getElementById(filename)!.children.length == 1) {
                        document.getElementById(filename)!.innerHTML += "<em class=\"bi bi-check-circle\" style=\"color: #157347\"></em>";
                    }
                } else {
                    this.loader.hide();
                    this.errorType = res.result;
                    this.errorMessage = res.content;
                }
            }, (resError) => {
                this.loader.hide();
            });
        }
    }

    async downloadAllAttachments() {
        if (this.ref && this.message && this.message.attachmentSize > 0) {
            var pjs: any[] = [];
            this.loader.show("OPEN.DOWNLOAD-ATTACHMENTS");

            for (const attachment of this.message.attachments) {
                await this.messageApi.downloadAttachment(attachment.filename, this.ref!).toPromise().then((res) => {
                    if (res.result == "SUCCESS") {
                        pjs.push(res.content);
                    }
                });
            }

            if (this.message.attachments.length != pjs.length) {
                this.loader.hide();
                this.errorType = "ERROR";
                this.errorMessage = "ERRORS.CREATE.DOWNLOAD-ATTACHMENTS";
            }

            if (pjs.length == 1) {
                this.loader.hide();
                const text = pjs[0].content;
                var download = document.createElement('a');
                download.href = 'data:' + pjs[0].type + ';base64,' + text;
                download.download = pjs[0].name;
                download.click();
                if (document.getElementById(pjs[0].name)!.children.length == 1) {
                    document.getElementById(pjs[0].name)!.innerHTML += "<em class=\"bi bi-check-circle\" style=\"color: #157347\"></em>";
                }
            } else if (pjs.length > 1) {

                const zip = new JSZip();
                const timestamp = Math.floor(Date.now() / 1000);
                const name = "attachments_" + timestamp + ".zip";

                // Pour chaque PJ
                for (const pj of pjs) {

                    // On décode les données du fichier
                    const data = atob(pj.content);

                    // On en fait un tableau de chaque caractère
                    const byteNumbers = new Array(data.length);
                    for (let i = 0; i < data.length; i++) {
                        byteNumbers[i] = data.charCodeAt(i);
                    }

                    // On converti en Uint8 nécessaire pour le faire un Blob
                    const byteArray = new Uint8Array(byteNumbers);

                    // On crée le Blob
                    const b: any = new Blob([byteArray], {type : '' + pj.type + ''});

                    // On l'ajoute à l'archive
                    zip.file(pj.name,b);

                    if (document.getElementById(pj.name)!.children.length == 1) {
                        document.getElementById(pj.name)!.innerHTML += "<em class=\"bi bi-check-circle\" style=\"color: #157347\"></em>";
                    }
                }

                // On génère l'archive + téléchargement
                zip.generateAsync({ type: 'blob' }).then((content) => {
                    if (content) {
                        FileSaver.saveAs(content, name);
                    }
                });
                this.loader.hide();
            } else {
                this.loader.hide();
                this.errorType = "ERROR";
                this.errorMessage = "ERRORS.CREATE.DOWNLOAD-ATTACHMENTS";
            }
        }
    }

    openRespondModal() {
        if (this.message && this.ref) {
            const modal = this.modalService.open(ResponseModalComponent, {size: 'lg', centered: true});
            modal.componentInstance.message = this.message;
            modal.componentInstance.ref = this.ref;
        }
    }

}
